export enum portalRoles {
  UNDEFINED = 'undefined',
  CHILD = 'child',
  EMPLOYEE = 'employee',
  GUARDIAN = 'guardian',
  MEMBERS = 'members',
  OTP = 'otp',
}
